import whatsappBar from '../../assets/images/whatsapp-bar.png';

const HotlineBar = () => (
  <a id="whatsapp-bar" href="https://wa.me/60176234270" className="fixed bottom-0 left-0 m-0 p-0">
    <img src={whatsappBar} alt="whatsapp-bar" className="m-0 h-11 w-screen p-0" />
  </a>
);

export default HotlineBar;
